// types.ts
// Export all type definitions for your Dung-Phat Refrigeration application

// Service type for your services page
export interface Service {
    id: string;
    title: string
    icon?: string;
    link: string;
    features?: string[];
}

// Pricing type for your pricing table
export interface PricingItem {
    id: string;
    service: string;
    capacity: string;
    price: string;
    features?: string[];
}

// Blog post type
export interface BlogPost {
    id: string;
    title: string;
    excerpt: string;
    content: string;
    author: string;
    date: string;
    imageUrl: string;
    tags?: string[];
}

// Testimonial type
export interface Testimonial {
    id: string;
    name: string;
    role: string;
    content: string;
    rating: number;
    avatar?: string;
    date: string;
}

// Contact form type
export interface ContactFormData {
    name: string;
    email: string;
    phone?: string;
    message: string;
    serviceInterest?: string;
}

// Appointment booking type
export interface Appointment {
    id?: string;
    customerName: string;
    customerPhone: string;
    serviceType: string;
    appointmentDate: string;
    appointmentTime: string;
    address: string;
    notes?: string;
    status?: 'pending' | 'confirmed' | 'completed' | 'cancelled';
    createdAt?: Date;
}
export interface Brand {
    id: string;
    name: string;
    logo: string;
    website?: string
}

export const ProductType = [
    "Máy lạnh treo tường",
    "Máy lạnh âm trần",
    "Máy lạnh tủ đứng",
    "Máy lạnh giấu trần ống gió",
    "Máy lạnh áp trần",
    "Hệ thống điều hòa Multi",
    "Hệ thống điều hòa VRV/VRF",
];

export const BRANDS: Brand[] = [
    {
        id: 'airwell',
        name: 'Airwell',
        logo: 'images/brands_logo/airwell.svg',
    },
    {
        id: 'akino',
        name: 'Akino',
        logo: 'images/brands_logo/akino.webp',
    },
    {
        id: 'alaska',
        name: 'Alaska',
        logo: 'images/brands_logo/alaska.webp',
    },
    {
        id: 'aqua',
        name: 'Aqua',
        logo: 'images/brands_logo/aqua.webp',
    },
    {
        id: 'asanzo',
        name: 'Asanzo',
        logo: 'images/brands_logo/asanzo.webp',
    },
    {
        id: 'carrier',
        name: 'Carrier',
        logo: 'images/brands_logo/carrier.svg',
    },
    {
        id: 'casper',
        name: 'Casper',
        logo: 'images/brands_logo/casper.webp',
    },
    {
        id: 'comfee',
        name: 'Comfee',
        logo: 'images/brands_logo/comfee.webp',
    },
    {
        id: 'daikin',
        name: 'Daikin',
        logo: 'images/brands_logo/daikin.svg',
    },
    {
        id: 'dairry',
        name: 'Dairry',
        logo: 'images/brands_logo/dairry.png',
    },
    {
        id: 'electrolux',
        name: 'Electrolux',
        logo: 'images/brands_logo/electrolux.webp',
    },
    {
        id: 'fujiaire',
        name: 'Fujiaire',
        logo: 'images/brands_logo/fujiaire.webp',
    },
    {
        id: 'fujitsu',
        name: 'Fujitsu',
        logo: 'images/brands_logo/fujitsu.svg',
    },
    {
        id: 'funiki',
        name: 'Funiki',
        logo: 'images/brands_logo/funiki.webp',
    },
    {
        id: 'general',
        name: 'General',
        logo: 'images/brands_logo/general.svg',
    },
    {
        id: 'gree',
        name: 'Gree',
        logo: 'images/brands_logo/gree.webp',
    },
    {
        id: 'hisense',
        name: 'Hisense',
        logo: 'images/brands_logo/hisense.webp',
    },
    {
        id: 'hitachi',
        name: 'Hitachi',
        logo: 'images/brands_logo/hitachi.svg',
    },
    {
        id: 'lg',
        name: 'LG',
        logo: 'images/brands_logo/lg.svg',
    },
    {
        id: 'midea',
        name: 'Midea',
        logo: 'images/brands_logo/midea.svg',
    },
    {
        id: 'mitsubishi-electric',
        name: 'Mitsubishi Electric',
        logo: 'images/brands_logo/mitsubishi-electric.svg',
    },
    {
        id: 'mitsubishi-heavy',
        name: 'Mitsubishi Heavy',
        logo: 'images/brands_logo/mitsubishi-heavy.svg',
    },
    {
        id: 'nagakawa',
        name: 'Nagakawa',
        logo: 'images/brands_logo/nagakawa.webp',
    },
    {
        id: 'panasonic',
        name: 'Panasonic',
        logo: 'images/brands_logo/panasonic.svg',
    },
    {
        id: 'reetech',
        name: 'Reetech',
        logo: 'images/brands_logo/reetech.webp',
    },
    {
        id: 'samsung',
        name: 'Samsung',
        logo: 'images/brands_logo/samsung.png',
    },
    {
        id: 'sharp',
        name: 'Sharp',
        logo: 'images/brands_logo/sharp.svg',
    },
    {
        id: 'sumikura',
        name: 'Sumikura',
        logo: 'images/brands_logo/sumikura.webp',
    },
    {
        id: 'toshiba',
        name: 'Toshiba',
        logo: 'images/brands_logo/toshiba.svg',
    }
];

export const getBrandById = (id: string): Brand | undefined => {
    return BRANDS.find(brand => brand.id === id);
};

export const getBrandByName = (name: string): Brand | undefined => {
    return BRANDS.find(brand => brand.name.toLowerCase() === name.toLowerCase());
};

export const getBrandLogo = (brandName: string): string => {
    const brand = BRANDS.find(b =>
        b.name.toLowerCase() === brandName.toLowerCase() ||
        b.id.toLowerCase() === brandName.toLowerCase()
    );
    return brand?.logo || 'images/brands_logo/default.webp'; // Fallback logo
};

export const getAllBrandNames = (): string[] => {
    return BRANDS.map(brand => brand.name);
};

export const getPopularBrands = (): Brand[] => {
    return BRANDS.filter(brand =>
        ['daikin', 'panasonic', 'lg', 'samsung', 'toshiba', 'mitsubishi-electric'].includes(brand.id)
    );
};
// Firebase document with ID
export interface FirebaseDoc<T> {
    id: string;
    data: T;
}

export { };